import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faGift } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { GiftSource } from '@soundxyz/utils/analytics';
import { Button } from '@components/main-components/button/Button';
import { trackClickEvent } from '@lib/analytics';

export const GiftingButton = ({
  releaseId,
  onClick,
  disabled,
  size,
  sourceComponent,
}: {
  releaseId: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled: boolean;
  size: 'L' | 'XL';
  sourceComponent: GiftSource;
}) => {
  return (
    <Button
      variant="tertiary"
      disabled={disabled}
      size="squared"
      iconOnly
      leadingIcon={
        <div className="group-hover:animate-shake group-disabled:animate-none">
          <FontAwesomeIcon icon={faGift} />
        </div>
      }
      label="Gift"
      className={twMerge(
        'group aspect-square flex-shrink-0 transition-all duration-200 ease-in-out disabled:shadow-transparent hover:bg-white hover:shadow-tertiary',
        size === 'L' ? ' h-11 w-11 flex-shrink-0 text-base-l ' : 'h-[52px] w-[52px] text-title-m',
      )}
      onClick={e => {
        e.stopPropagation();
        trackClickEvent({
          event: 'Gift Clicked',
          properties: {
            associationId: releaseId,
            associationType: 'Release',
            sourceComponent,
          },
        });
        onClick(e);
      }}
    />
  );
};
